import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { FC, lazy, Suspense } from 'react'
import { EnhancedProductViewContainerProps } from './EnhancedProductViewContainer'

const EnhancedProductViewContainerLazy: FC<EnhancedProductViewContainerProps> = lazy(
  () => import('./EnhancedProductViewContainer')
)

const EnhancedProductViewContainer: FC<EnhancedProductViewContainerProps> = props => {
  return (
    <Suspense fallback={FallbackComponent}>
      <EnhancedProductViewContainerLazy {...props} />
    </Suspense>
  )
}

export default EnhancedProductViewContainer
